export default __webpack_public_path__ + "static/media/kpmg.fda0da50.svg";